import { ChangeEvent, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import useAllInvestment from "../../custom-hooks/useAllInvestment";
import ButtonLoader, { Loader } from "../../UI/Loaders/Loaders";
import CustomSelectDropdown from "../CustomHTMLElements/CustomSelectDropdown";
import Paginator from "../Pagination/Pagination.component";
import { showModal } from "../../redux/actions/modal";
import { formatMoney } from "../../helpers/formatter";
import { attachClassNameToTag } from "../../helpers/attachClassNameToTag";
import { getTokenFromLocalStorage } from "../../helpers/localStorage";
import { BASE_URL } from "../../appConstants";
import { appInsights } from "../../config/appInsights";
import {
  handleRollOverModalToggle,
  InvestmentStatus,
} from "../Investor/Tabs/EachInvestorInvestment/helper";
import CloseInvestmentModal from "../../NewComponents/CloseInvestmentModal";
import useInvestmentClosure from "../../custom-hooks/useInvestmentClosure";
import * as ajaxEndpoints from "../../api/ajax-endpoints";
import { message } from "antd";
import { ISelectedRecord } from "../Investor/Tabs/EachInvestorInvestment/EachInvestorInvestment";
import { IInvestmentQueryItem } from "../../interfaces/funderInvestment";
import { formatTenor } from "../../helpers/formatTenor";
import RollOverModal from "../Investor/Components/RollOverModal/RollOverModal";
import PrincipalOrInterestModal from "../Investor/Components/PrincipalOrInterestModal/PrincipalOrInterestModal";
import { RollOverType } from "../Investor/Tabs/EachInvestorInvestment/types";
import { RootState } from "../../redux/store";
import { setAdvancedInvestmentSearchParams } from "../../redux/actions/investments";

export interface IProps {
  id: number;
  name: string;
  description: string;
}

const AllInvestments = () => {
  const [preState, setPreState] = useState({
    pageNumber: 1,
    size: 20,
    startDate: "",
    endDate: "",
  });

  const [downloadLoading, setDownloadLoading] = useState(false);
  const [state, setState] = useState({
    pageNumber: 1,
    size: 20,
    startDate: "",
    endDate: "",
  });
  const [investmentID, setInvestmentID] = useState<number | null>(null);
  const [maturityDate, setMaturityDate] = useState<string>("");
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState<
    ISelectedRecord | undefined
  >();
  const [selectedRollOverType, setSelectedRollOverType] =
    useState<RollOverType | null>(null);

  const searchParams = useSelector(
    (state: RootState) => state?.investmentSearchReducer,
  );

  useEffect(() => {
    appInsights.trackPageView({
      name: "Investment Info  - (AllInvestments.jsx)",
      isLoggedIn: true,
    });
  }, []);

  const dispatch = useDispatch();
  const history = useHistory();

  const onClear = () => {
    setState({
      pageNumber: 1,
      size: 20,
      startDate: "",
      endDate: "",
    });
    setPreState({
      pageNumber: 1,
      size: 20,
      startDate: "",
      endDate: "",
    });
    dispatch(
      setAdvancedInvestmentSearchParams({
        currency: "",
        searchValue: "",
        aggregatorId: "",
        dateSearchMode: 0,
        investmentStatus: 0,
        legalEntity: "",
      }),
    );
  };

  const handleDownload = () => {
    setDownloadLoading(true);

    let token = getTokenFromLocalStorage();
    let queryParams = "";
    if (preState.startDate && preState.endDate) {
      queryParams = `?FromDate=${preState.startDate}&ToDate=${preState.endDate}`;
    }
    if (searchParams?.aggregatorId) {
      queryParams = queryParams
        ? `${queryParams}&AggregatorId=${searchParams.aggregatorId}`
        : `?AggregatorId=${searchParams.aggregatorId}`;
    }
    if (searchParams?.searchValue) {
      queryParams = queryParams
        ? `${queryParams}&FunderName=${searchParams.searchValue}`
        : `?FunderName=${searchParams.searchValue}`;
    }
    if (searchParams?.currency) {
      queryParams = queryParams
        ? `${queryParams}&Currency=${searchParams.currency}`
        : `?Currency=${searchParams.currency}`;
    }
    if (searchParams?.legalEntity) {
      queryParams = queryParams
        ? `${queryParams}&LegalEntity=${searchParams.legalEntity}`
        : `?LegalEntity=${searchParams.legalEntity}`;
    }
    if (searchParams?.dateSearchMode) {
      queryParams = queryParams
        ? `${queryParams}&DateSearchMode=${searchParams.dateSearchMode}`
        : `?DateSearchMode=${searchParams.dateSearchMode}`;
    }
    if (searchParams?.investmentStatus) {
      queryParams = queryParams
        ? `${queryParams}&InvestmentStatus=${searchParams.investmentStatus}`
        : `?InvestmentStatus=${searchParams.investmentStatus}`;
    }
    if (searchParams?.relationshipManagerId) {
      queryParams = queryParams
        ? `${queryParams}&RelationshipManagerId=${searchParams.relationshipManagerId}`
        : `?RelationshipManagerId=${searchParams.relationshipManagerId}`;
    }
    fetch(BASE_URL + `/account/download_investments${queryParams}`, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
        Authorization: "Bearer " + token,
      },
      // body: JSON.stringify(data)
    })
      .then((response) => {
        setDownloadLoading(false);
        if (response.status === 200 || response.status === 201) {
          response.blob().then((blob) => {
            const url = window.URL.createObjectURL(new Blob([blob]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              `${
                preState.startDate && preState.endDate
                  ? `Investments from ${preState.startDate} to ${preState.endDate}.csv`
                  : `Investments.csv`
              }`,
            );
            link.click();
          });
        }

        if (response.status === 403 || response.status === 401) {
          localStorage.removeItem("sso_auth_token");
          history.push("/login");
        }

        if (response.status >= 500) {
          // this.setState({ error: "Something went wrong. Please check your internet connection and try again" });
        }
      })
      .catch((error: any) => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "AllInvestments.jsx",
          },
        });
        // this.setState({ loading: false, error: "Something went wrong. Please check your internet connection and try again" });
        setDownloadLoading(false);
      });
  };
  const [count, setCount] = useState(null);

  const { data, status, error, refetch } = useAllInvestment({
    pageNumber: preState.pageNumber,
    size: preState.size,
    startDate: preState.startDate,
    endDate: preState.endDate,
    currency: searchParams?.currency,
    searchValue: searchParams?.searchValue,
    dateSearchMode: searchParams?.dateSearchMode,
    investmentStatus: searchParams?.investmentStatus,
    legalEntity: searchParams?.legalEntity,
    relationshipManagerId: searchParams?.relationshipManagerId,
  });

  const {
    mutate: closeInvestment,
    isLoading: isLoadingInvestmentClosure,
    error: investmentClosureError,
    data: closureData,
  } = useInvestmentClosure(
    ajaxEndpoints.CLOSE_WITHDRAW_INVESTMENT,
    (responseData: any) => {
      message.success(
        responseData?.message || "Investment closed successfully!",
      );
      setIsConfirmationModalOpen(false);
      refetch();
    },
  );

  const handleInvestmentClosure = async (closeDate: string) => {
    await closeInvestment({
      investment_id: investmentID,
      close_date: closeDate,
    });
  };

  if (data) {
    if (count === null) {
      setCount(data.totalCount);
    }
  }
  const resetTable = () => {
    setCount(null);
    setPreState({ ...state, pageNumber: 1 });
  };

  const modalHandler = (modalData: string, type: string) => {
    dispatch(
      showModal({
        modalIdentifier: "audittrail",
        dataRecord: modalData,
        action: "customrange",
        type,
      }),
    );
  };
  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = e.target;
    setState({ ...state, [name]: value });
  };

  const filterData = () => {
    if (state.startDate && state.endDate) {
      const diffTime =
        new Date(state.endDate).valueOf() - new Date(state.startDate).valueOf();
      if (diffTime < 0) {
        modalHandler("", "alert");
        return;
      }
    }
    setPreState(state);
    resetTable();
  };
  let RenderedComponent = null;
  if (!data && status !== "loading") {
    RenderedComponent = (
      <div>
        <div className="grid__padding animated fadeInRight">
          <h4 className="center-txt">
            <i className="fas fa-bell" /> Unable to Fetch Investments
          </h4>
        </div>
      </div>
    );
  } else if (status === "loading") {
    RenderedComponent = (
      <Loader centered={true} text="Loading Investments..." />
    );
  } else {
    if (error) {
      RenderedComponent = (
        <div>
          <div className="grid__padding animated fadeInRight">
            <h4 className="center-txt p-y-5">
              <i className="fas fa-bell" /> There was an issue while fetching
              investments, Please Reload The Page{" "}
            </h4>
          </div>
        </div>
      );
    } else if (
      (data && data.data && data.data.length === 0) ||
      (data && !data.data)
    ) {
      RenderedComponent = (
        <div className="centerLoader">
          <div className="grid__padding animated fadeInRight">
            <h4 className="center-txt p-y-5">
              <i className="fas fa-bell" /> There are currently no Investment.
            </h4>
          </div>
        </div>
      );
    } else {
      RenderedComponent = (
        <div className="row m-x-sm m-y-2 grid__padding">
          <div className="table-responsive">
            <table className="table">
              <thead className="bg-lighter-grey">
                <tr>
                  <th>Ref No</th>
                  <th>Investor</th>
                  <th>Product Name</th>
                  <th>Amount Invested</th>
                  <th>Tenor</th>
                  <th>Deposit Type</th>
                  <th>Relationship Manager</th>
                  <th>Legal Entity</th>
                  <th>Status</th>
                  <th>Date Invested</th>
                  <th>Maturity Date</th>
                  <th>Total Deposits</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {data.data &&
                  data.data.map(
                    (request: IInvestmentQueryItem, _id: number) => {
                      const {
                        funder_name,
                        principal_amount,
                        currency,
                        reference_number,
                        tenure,
                        tenor_unit,
                        effective_date,
                        maturity_date,
                        investment_status,
                        investment_product_id,
                        id: investment_id,
                        legal_entity,
                        deposit_type,
                        investment_product_name,
                        total_deposits,
                        relationship_manager_name,
                      } = request;
                      return (
                        <tr key={_id}>
                          <td>{reference_number}</td>
                          <td>{funder_name}</td>
                          <td>{investment_product_name}</td>
                          <td>{formatMoney(principal_amount, currency)}</td>
                          <td>{formatTenor(tenure, tenor_unit)}</td>
                          <td>{deposit_type}</td>
                          <td>{relationship_manager_name}</td>
                          <td>{legal_entity}</td>
                          <td>
                            <span
                              className={attachClassNameToTag(
                                investment_status,
                              )}
                            >
                              {attachClassNameToTag(investment_status)}
                            </span>
                          </td>
                          <td>
                            {effective_date
                              ? effective_date.substring(0, 10)
                              : "N/A"}
                          </td>
                          <td>
                            {maturity_date
                              ? maturity_date.substring(0, 10)
                              : "N/A"}
                          </td>
                          <td>{formatMoney(total_deposits, currency)}</td>
                          <td>
                            <div className="dropdown">
                              <button
                                className="btn zoom-element btn-slim dropdown-toggle"
                                type="button"
                                id="dropdownMenuButton"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                              ></button>
                              <div
                                className="dropdown-menu"
                                style={{ textAlign: "center" }}
                                aria-labelledby="dropdownMenuButton"
                              >
                                {investment_status ===
                                InvestmentStatus.MATURED ? (
                                  <span
                                    className="cursor-pointer dropdown-item"
                                    id="custom-rollover-button"
                                    onClick={() => {
                                      handleRollOverModalToggle();
                                      setSelectedRecord({
                                        id: investment_id,
                                        investment_product_id:
                                          investment_product_id ?? undefined,
                                      });
                                    }}
                                  >
                                    ROLL OVER
                                  </span>
                                ) : null}
                                <span
                                  className="cursor-pointer dropdown-item"
                                  onClick={() => {
                                    history.push(
                                      `/investment-details/${investment_id}`,
                                    );
                                  }}
                                >
                                  VIEW DETAILS
                                </span>
                                {investment_status ===
                                InvestmentStatus.MATURED ? (
                                  <span
                                    className="cursor-pointer dropdown-item"
                                    onClick={() => {
                                      setIsConfirmationModalOpen(true);
                                      setInvestmentID(investment_id);
                                      setMaturityDate(maturity_date || "");
                                    }}
                                  >
                                    CLOSE
                                  </span>
                                ) : null}
                              </div>
                            </div>
                          </td>
                        </tr>
                      );
                    },
                  )}
              </tbody>
            </table>
          </div>
        </div>
      );
    }
  }

  return (
    <div>
      <div className="datatable-wrapper">
        <div className="table-view speed-1x animated fadeInRight">
          <div className="d-flex flex-row flex-wrap mb-4">
            <h3 className="page-title">All Investments</h3>
            <button
              type="button"
              className="btn advancly-white-btn m-0"
              onClick={handleDownload}
              disabled={status === "loading" || downloadLoading}
            >
              <i className="fas fa-download m-r-1" />
              Download {downloadLoading && <ButtonLoader />}
            </button>
          </div>
          <div className="row">
            <div className="form-group col-md-2">
              <label>From</label>
              <div className="input-group">
                <input
                  type="date"
                  name="startDate"
                  className="form-control"
                  value={state.startDate}
                  onChange={(e) => handleChange(e)}
                />
              </div>
            </div>
            <div className="form-group col-md-2">
              <label>To</label>
              <div className="input-group">
                <input
                  type="date"
                  className="form-control"
                  name="endDate"
                  value={state.endDate}
                  onChange={(e) => handleChange(e)}
                />
              </div>
            </div>
            <div className="form-group col-md-2" style={{ marginTop: "30px" }}>
              <div className="input-group">
                <CustomSelectDropdown
                  name="size"
                  onChange={(e) => handleChange(e)}
                  value={state.size}
                  isShowDropdownArrow
                >
                  <option value={10}>10 Entries</option>
                  <option value={20}>20 Entries</option>
                  <option value={50}>50 Entries</option>
                  <option value={100}>100 Entries</option>
                </CustomSelectDropdown>
              </div>
            </div>
            <div className="form-group col-md-2" style={{ marginTop: "30px" }}>
              <div className="input-group">
                <button
                  className="btn advancly-white-btn ml-2 form-control"
                  onClick={() => {
                    dispatch(
                      showModal({
                        modalIdentifier: "advancedinvestmentsearch",
                        dataRecord: {},
                      }),
                    );
                  }}
                >
                  <i className="fas fa-search" />
                  &nbsp; Advance Search
                </button>
              </div>
            </div>
            <div className="form-group col-md-2" style={{ marginTop: "30px" }}>
              <div className="input-group">
                <button
                  className="btn advancly-btn form-control"
                  onClick={filterData}
                  disabled={status === "loading" || downloadLoading}
                >
                  Search
                </button>
              </div>
            </div>
            <div className="form-group col-md-2" style={{ marginTop: "30px" }}>
              <div className="input-group">
                <button
                  type="button"
                  className="btn advancly-red-btn btn-md"
                  style={{ height: "3rem" }}
                  onClick={onClear}
                >
                  Clear
                </button>
              </div>
            </div>
          </div>
          {/*Datatable || Loader || Error Message*/}
          {RenderedComponent}
          {data && data?.data && (
            <Paginator
              size={preState.size}
              page={preState.pageNumber}
              count={data?.totalCount}
              changeCurrentPage={(pageNumber: number) =>
                setPreState({ ...state, pageNumber })
              }
            />
          )}
        </div>
      </div>
      {isConfirmationModalOpen ? (
        <CloseInvestmentModal
          onConfirm={handleInvestmentClosure}
          onClose={() => {
            setIsConfirmationModalOpen(false);
            setInvestmentID(null);
            setMaturityDate("");
          }}
          isOpen={isConfirmationModalOpen}
          isLoading={isLoadingInvestmentClosure}
          maturityDate={maturityDate}
        />
      ) : null}
      <PrincipalOrInterestModal
        setSelectedRollOverType={setSelectedRollOverType}
      />
      {selectedRecord && (
        <>
          <RollOverModal
            selectedRollOverType={selectedRollOverType}
            selectedRecord={selectedRecord}
          />
        </>
      )}
    </div>
  );
};

export default AllInvestments;
